import type { MobileAppConfig } from '@tbitop/environment/mobile-app';
import { CapacitorAdapter } from '@tbitop/keycloak/capacitor';
import { isCapacitor } from '@tbitop/platform';

export const appConfig: MobileAppConfig = {
  backendApi: 'vert-api',
  clientId: 'sales-planner-mobile',
  resourceName: 'vert-api',
  requiredRoles: ['AussendienstDefault'],
  redirectUris: {
    ios: 'capacitor://salesplanner.teambeverage.cloud',
    android: 'cloud.teambeverage.salesplanner://callback',
  },
  adapter: isCapacitor() ? CapacitorAdapter : undefined,
};
